import React, { useEffect } from 'react'
import Raven from 'raven-js'
import groundcover from '@groundcover/browser'
import { getEnvVar } from '@client-hub/shared/utils/env'
import { EnvironmentVariable } from '@client-hub/shared/constants/env'
import { log, LogContext } from '@client-hub/shared/react/hooks/useLogger'

const Telemetry: React.FC = () => {
  useEffect(() => {
    if (process.env.NX_GROUNDCOVER_API_KEY && process.env.NX_GROUNDCOVER_DSN) {
      groundcover.init({
        apiKey: process.env.NX_GROUNDCOVER_API_KEY,
        dsn: process.env.NX_GROUNDCOVER_DSN,
        environment: getEnvVar(EnvironmentVariable.TELEMETRY_ENV),
        appId: 'client-hub',
        cluster: `${getEnvVar(EnvironmentVariable.TELEMETRY_ENV)}-ue1`,
        options: {
          sessionSampleRate: 1.0,
          enableMasking: true,
          enabledEvents: ['dom', 'exceptions', 'logs', 'pageload', 'navigation', 'performance'],
        },
      })
    }
    //same for sentry initialize only if dsn exist
    if (process.env.NX_SENTRY_DSN && getEnvVar(EnvironmentVariable.TELEMETRY_ENV) && process.env.NX_SENTRY_RELEASE) {
      Raven.config(process.env.NX_SENTRY_DSN, {
        environment: getEnvVar(EnvironmentVariable.TELEMETRY_ENV),
        release: process.env.NX_SENTRY_RELEASE,
      }).install()
    }
  }, [])

  return null
}

export const LogProvider: React.FC = ({ children }) => <LogContext.Provider value={log}>{children}</LogContext.Provider>

export default Telemetry
